(ns minorodata.connections.sources.xero
  (:require [minorodata.app.utils :as app.utils]
            [clojure.string :as c.string]
            [cljs.spec.alpha :as spec]
            [spec-tools.core :as st]
            [mold-forms.core :as form-component]))


(spec/def ::name
  (spec/and (st/spec string? {:reason "Please provide a name for the source"})
            (st/spec (complement c.string/blank?) {:reason "Name can't be empty"})))


(spec/def ::description
  (spec/nilable string?))


(spec/def ::auth-credentials-id
  (spec/and (st/spec string? {:reason "Please provide a valid auth token"})
            (st/spec (complement c.string/blank?) {:reason "Please provide a valid auth token"})))


(spec/def ::auth-credentials
  (spec/keys :req-un [::auth-credentials-id]))


(spec/def ::xero-form
  (spec/keys :req-un [::name ::auth-credentials]
             :opt-un [::description]))


(def source
  {:id                "xero"
   :enabled           false
   :name              "Xero (Deprecated)"
   :description       "Online accounting software for your small business"
   :image-source      "xero.png"
   :tags              ["admin-finance"]

   :preview-formatter (fn [source]
                        (if (:is-token-valid source)
                          (str "Authenticated by token")
                          [:span {:class "text-kleene-error-01"
                                  :title         "TOKEN EXPIRED"}
                           "Authentication unsuccessful, please try re-connecting"]))

   :form              {:format-for-api
                       (fn format-for-api [{:keys [auth-credentials name description]}]
                         {:source-type "xero"
                          :name        name
                          :description description
                          :source      {:auth-credentials-id (:auth-credentials-id auth-credentials)
                                        :is-token-valid      (:is-token-valid auth-credentials)
                                        :tenants             (:tenants auth-credentials)
                                        :has-third-leg       true}})

                       :format-for-inputs
                       (fn format-for-inputs [{:keys [source name description]}]
                         (let [{:keys [auth-credentials-id is-token-valid tenants]} source]
                           {:name                name
                            :description         description
                            :auth-credentials    (when (and (some? auth-credentials-id)
                                                            (some? is-token-valid))
                                                   {:auth-credentials-id auth-credentials-id
                                                    :is-token-valid      is-token-valid
                                                    :tenants             tenants})
                            :auth-credentials-id auth-credentials-id
                            :tenants             tenants
                            :is-token-valid      is-token-valid}))

                       ;; TODO:
                       ;; Replace :format-for-api and :format-for-fields with a single :mapping, like so
                       ;; {:block-type :input
                       ;;  :name       :some-name
                       ;;  :mapping    [:credentials :some_name]}
                       ;; Also, think of having `:input-type :hidden` blocks as placeholders
                       ;; for static fields in the final configuration.

                       :validate
                       (partial form-component/validate-form ::xero-form)

                       :id
                       :xero-form

                       :blocks
                       [{:block-type :input
                         :label      "Source name"
                         :required   true
                         :name       :name
                         :value      ""}

                        {:block-type :input
                         :label      "Description"
                         :name       :description
                         :value      ""}

                        {:block-type           :oauth
                         :label                "Xero Login"
                         :name                 :auth-credentials
                         :required             true

                         :request-uri          "https://login.xero.com/identity/connect/authorize"
                         :params-processor     (fn [{:keys [client-id redirect-uri state scope response-type]}]
                                                 {:response_type response-type
                                                  :scope         scope
                                                  :client_id     client-id
                                                  :redirect_uri  redirect-uri
                                                  :state         state})

                         :response-processor   (fn [data]
                                                 (select-keys data [:auth-credentials-id :is-token-valid :tenants]))

                         :oauth-connector-type "xero"
                         :has-third-leg        true

                         :response-type        "code"
                         :client-id            "DCE5859F57724088B012BB4807348D9D"
                         :scope                "accounting.reports.read accounting.transactions.read offline_access accounting.contacts.read accounting.settings.read accounting.attachments.read accounting.journals.read"}

                        {:block-type :submit
                         :content    "SAVE"}]}

   :extract-form      {:format-for-api
                       (fn format-for-api [{:keys [name description status action destination-table report tenant-id
                                                   extract-type payment-type]}]
                         {:name          name
                          :description   description
                          :status        status
                          :output-tables [destination-table]
                          :config        {:extracts [{:action            action
                                                      :report            report
                                                      :destination-table destination-table
                                                      :extract-type      extract-type
                                                      :tenant-id         tenant-id
                                                      :payment-type      payment-type}]}})

                       :format-for-inputs
                       (fn format-for-inputs [{:extract/keys [name description status config source-id]}]
                         (let [extract (get-in config [:extracts 0])]
                           (merge
                            (select-keys extract [:report :action :destination-table :extract-type :tenant-id :payment-type])
                            (app.utils/keep-non-nil-keys
                             {:name          name
                              :description   description
                              :status        status
                              :output-tables []

                              :source-id     source-id}))))

                       :validate
                       (constantly nil)

                       :id
                       :xero-extract-form

                       :blocks
                       [{:block-type :input
                         :label      "Extract name"
                         :required   true
                         :name       :name
                         :value      ""}

                        {:block-type :input
                         :label      "Description"
                         :name       :description
                         :value      ""}

                        {:block-type :select
                         :label      "Status"
                         :name       :status
                         :options    [{:name "Active" :value "active"}
                                      {:name "Paused" :value "paused"}]
                         :required   true
                         :value      "active"}

                        {:block-type :subtitle
                         :content    "Extract Configuration"}

                        {:block-type :form-value
                         :name       :source-id}

                        {:block-type           :source-select
                         :name                 :tenant-id
                         :label                "Tenant"
                         :empty-option-text    "Select tenant"
                         :required             true
                         :source-options-field :tenants
                         :options-name-path    [:tenantname]
                         :options-value-path   [:tenantid]}

                        {:block-type :select
                         :label      "Report"
                         :name       :report
                         :options    [{:name "Daily Bank Transactions" :value "daily-bank-transactions"}
                                      {:name "Invoices" :value "invoices"}
                                      {:name "Contacts" :value "contacts"}
                                      {:name "Accounts" :value "accounts"}
                                      {:name "Journals" :value "journals"}
                                      {:name "Credit Notes" :value "creditnotes"}]
                                      ;; {:name "Balance Sheet Report" :value "reports-balance-sheet"}
                                      ;; {:name "Profit and Loss Report" :value "reports-profit-and-loss"}]
                         :disabled   false
                         :required   true
                         :value      "daily-bank-transactions"}

                        {:content    [:p
                                      [:b "Included fields:"]
                                      [:br]
                                      [:ul
                                       [:li "ContactID"]
                                       [:li "Name"]
                                       [:li "DateString"]
                                       [:li "LineAmountTypes"]
                                       [:li "SubTotal"]
                                       [:li "TotalTax"]
                                       [:li "Total"]
                                       [:li "UpdatedDateUTC"]
                                       [:li "FullyPaidOnDate"]
                                       [:li "BankTransactionID"]
                                       [:li "AccountID"]
                                       [:li "Code"]
                                       [:li "Type"]
                                       [:li "IsReconciled"]]]
                         :conditions [[:eq [:report :value] "daily-bank-transactions"]]}

                        {:content    [:p
                                      [:b "Included fields:"]
                                      [:br]
                                      [:ul
                                       [:li "Type"]
                                       [:li "Contact"]
                                       [:li "Date"]
                                       [:li "DueDate"]
                                       [:li "Status"]
                                       [:li "LineAmountTypes"]
                                       [:li "LineItems"]
                                       [:li "SubTotal"]
                                       [:li "TotalTax"]
                                       [:li "Total"]
                                       [:li "TotalDiscount"]
                                       [:li "UpdatedDateUTC"]
                                       [:li "CurrencyCode"]
                                       [:li "CurrencyRate"]
                                       [:li "InvoiceID"]
                                       [:li "InvoiceNumber"]
                                       [:li "Reference"]
                                       [:li "BrandingThemeID"]
                                       [:li "Url"]
                                       [:li "SentToContact"]
                                       [:li "ExpectedPaymentDate"]
                                       [:li "PlannedPaymentDate"]
                                       [:li "HasAttachments"]
                                       [:li "RepeatingInvoiceID"]
                                       [:li "Payments"]
                                       [:li "CreditNotes"]
                                       [:li "Prepayments"]
                                       [:li "Overpayments"]
                                       [:li "AmountDue"]
                                       [:li "AmountPaid"]
                                       [:li "CISDeduction"]
                                       [:li "FullyPaidOnDate"]
                                       [:li "AmountCredited"]]]
                         :conditions [[:eq [:report :value] "invoices"]]}

                        {:content    [:p
                                      [:b "Included fields:"]
                                      [:br]
                                      [:ul
                                       [:li "Type"]
                                       [:li "Contact"]
                                       [:li "Date"]
                                       [:li "Status"]
                                       [:li "LineAmountTypes"]
                                       [:li "LineItems"]
                                       [:li "SubTotal"]
                                       [:li "TotalTax"]
                                       [:li "Total"]
                                       [:li "CISDeduction"]
                                       [:li "UpdatedDateUTC"]
                                       [:li "CurrencyCode"]
                                       [:li "FullyPaidOnDate"]
                                       [:li "CreditNoteID"]
                                       [:li "CreditNoteNumber"]
                                       [:li "Reference"]
                                       [:li "SentToContact"]
                                       [:li "CurrencyRate"]
                                       [:li "RemainingCredit"]
                                       [:li "Allocations"]
                                       [:li "BrandingThemeID"]
                                       [:li "HasAttachments"]]]
                         :conditions [[:eq [:report :value] "creditnotes"]]}

                        {:content    [:p
                                      [:b "Included fields:"]
                                      [:br]
                                      [:ul
                                       [:li "ContactID"]
                                       [:li "ContactStatus"]
                                       [:li "Name"]
                                       [:li "FirstName"]
                                       [:li "LastName"]
                                       [:li "EmailAddress"]
                                       [:li "SkypeUserName"]
                                       [:li "BankAccountDetails"]
                                       [:li "TaxNumber"]
                                       [:li "AccountsReceivableTaxType"]
                                       [:li "AccountsPayableTaxType"]
                                       [:li "UpdatedDateUTC"]
                                       [:li "DefaultCurrency"]]]
                         :conditions [[:eq [:report :value] "contacts"]]}

                        {:content    [:p
                                      [:b "Included fields:"]
                                      [:br]
                                      [:ul
                                       [:li "Code"]
                                       [:li "Name"]
                                       [:li "Type"]
                                       [:li "BankAccountNumber"]
                                       [:li "Status"]
                                       [:li "Description"]
                                       [:li "BankAccountType"]
                                       [:li "CurrencyCode"]
                                       [:li "TaxType"]
                                       [:li "EnablePaymentsToAccount"]
                                       [:li "ShowInExpenseClaims"]
                                       [:li "AccountID"]
                                       [:li "Class"]
                                       [:li "SystemAccount"]
                                       [:li "ReportingCode"]
                                       [:li "ReportingCodeName"]
                                       [:li "HasAttachments"]
                                       [:li "UpdatedDateUTC"]
                                       [:li "AddToWatchlist"]]]
                         :conditions [[:eq [:report :value] "accounts"]]}

                        {:content    [:p
                                      [:b "Included fields:"]
                                      [:br]
                                      [:ul
                                       [:li "Fields"]
                                       [:li "ReportDate"]
                                       [:li "ReportID"]
                                       [:li "ReportName"]
                                       [:li "ReportTitles"]
                                       [:li "ReportType"]
                                       [:li "Rows"]
                                       [:li "UpdatedDateUTC"]]]
                         :conditions [[:eq [:report :value] "reports-balance-sheet"]
                                      [:eq [:report :value] "reports-profit-and-loss"]]}

                        {:block-type :subtitle
                         :content    "Data loading options"}

                        {:block-type :select
                         :label      "Extract type"
                         :name       :extract-type
                         :options    [{:name "Incremental" :value "incremental"}]
                         :required   true
                         :value      "incremental"
                         :conditions [[:eq [:report :value] "daily-bank-transactions"]]}

                        {:block-type :select
                         :label      "Extract type"
                         :name       :extract-type
                         :options    [{:name "Incremental" :value "incremental"}
                                      {:name "Full"        :value "full-load"}]
                         :required   true
                         :value      "incremental"
                         :conditions [[:eq [:report :value] "invoices"]
                                      [:eq [:report :value] "contacts"]
                                      [:eq [:report :value] "accounts"]
                                      [:eq [:report :value] "reports-balance-sheet"]
                                      [:eq [:report :value] "reports-profit-and-loss"]
                                      [:eq [:report :value] "journals"]
                                      [:eq [:report :value] "creditnotes"]]}

                        {:block-type :select
                         :label      "Payment Type"
                         :name       :payment-type
                         :options    [{:name "Cash" :value "cash"}
                                      {:name "Accrual" :value "accrual"}]
                         :required   true
                         :value      "accrual"
                         :conditions [[:eq [:report :value] "journals"]]}


                        {:block-type :select
                         :label      "Load method"
                         :name       :action
                         :options    [{:name "Drop, Create, Load" :value "replace"}
                                      {:name "Truncate, Load"     :value "reload"}
                                      {:name "Append"             :value "append"}]
                         :required   true
                         :value      "replace"}

                        {:content "Drop table, Create table, load entire table (selected columns)"
                         :conditions [[:eq [:action :value] "replace"]]}

                        {:content "Truncate table, Load entire table (selected columns)"
                         :conditions [[:eq [:action :value] "reload"]]}

                        {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
                         :conditions [[:and [[:action :value] [:extract-type :value]] ["append" "full-load"]]]}

                        {:content "Find max record in destination table of specified incremental key. Select rows where results of incremental key greater than max record of incremental key in destination table. Insert rows (selected columns) into the destination table no truncation."
                         :conditions [[:and [[:action :value] [:extract-type :value]] ["append" "incremental"]]]}

                        {:block-type :subtitle
                         :content    "Destination table"}

                        {:block-type  :warehouse-destination
                         :name        :destination-table}

                        {:block-type :submit
                         :content    "SAVE"}]}})
